/**
 * Custom Theme JavaScript
 * Extracted from theme.liquid for better maintainability, caching, and performance
 * 
 * This file contains:
 * - Page reload logic for bfcache handling
 * - Country detection and display
 * - Bundle variant selection
 * - Menu and cart drawer click-outside handlers
 */

(function () {
    'use strict';

    /**
     * ========================================
     * Page Navigation/Reload Handling
     * Handles back-forward cache (bfcache) to ensure fresh page state
     * ========================================
     */
    function initPageReloadHandling() {
        // Check if navigation was via back/forward
        if (window.performance) {
            const navEntries = window.performance.getEntriesByType('navigation');
            if ((navEntries.length && navEntries[0].type === 'back_forward') ||
                (window.performance.navigation && window.performance.navigation.type === 2)) {
                window.location.reload();
            }
        }

        // Handle pageshow event for bfcache
        window.addEventListener('pageshow', function (event) {
            if (event.persisted) {

                // iOS Safari restores the full DOM from bfcache, which means any open
                // menu drawer will briefly flash open before the page reloads.
                // Immediately hide the menu and strip all open state synchronously
                // so there is zero visible flash before the reload fires.
                try {
                    // Force-close the menu drawer details element
                    var menuDetails = document.getElementById('Details-menu-drawer-container');
                    if (menuDetails) {
                        menuDetails.removeAttribute('open');
                        menuDetails.classList.remove('menu-opening');
                    }
                    // Remove all submenu open states
                    document.querySelectorAll('details[open]').forEach(function (el) {
                        el.removeAttribute('open');
                        el.classList.remove('menu-opening');
                    });
                    document.querySelectorAll('.submenu-open').forEach(function (el) {
                        el.classList.remove('submenu-open');
                    });
                    // Remove body classes added by openMenuDrawer
                    document.body.classList.remove(
                        'menu-drawer-open',
                        'overflow-hidden-tablet',
                        'overflow-hidden-desktop'
                    );
                    // Hide the drawer panel itself immediately via inline style
                    // so it doesn't render during the brief time before reload
                    var menuDrawer = document.getElementById('menu-drawer');
                    if (menuDrawer) {
                        menuDrawer.style.visibility = 'hidden';
                        menuDrawer.style.transform = 'translateX(-100%)';
                    }
                } catch (e) {
                    // Silently ignore — reload below will correct any state
                }

                window.location.reload();
            }
        });
    }

    /**
     * ========================================
     * Country Detection and Display
     * Fetches visitor's country and updates all country display elements
     * ========================================
     */
    async function fetchDatacart() {
        try {
            let fetchUrl;
            if (Shopify.routes && Shopify.routes.root) {
                fetchUrl = Shopify.routes.root + 'browsing_context_suggestions.json';
            } else {
                fetchUrl = '/browsing_context_suggestions.json';
            }

            const response = await fetch(fetchUrl);
            const jsonResponse = await response.json();

            if (jsonResponse && jsonResponse.detected_values && jsonResponse.detected_values.country && jsonResponse.detected_values.country.handle) {
                window.countryCode = jsonResponse.detected_values.country.handle;
                console.log(`${window.countryCode}`, 'code code');

                // Update text content for country code elements
                const countryElements = [
                    '[data-product-country-bar]',
                    '[data-product-country-code]',
                    '[data-product-country-code-collaps]',
                    '[data-product-country-code-des]'
                ];

                countryElements.forEach(function (selector) {
                    const el = document.querySelector(selector);
                    if (el) {
                        el.textContent = window.countryCode;
                    }
                });

                // Update SVG Flag
                const flagImg = document.querySelector('[data-product-free-shipping-flag]');
                if (flagImg) {
                    flagImg.src = 'https://flagcdn.com/' + window.countryCode.toLowerCase() + '.svg';
                }
            }
        } catch (error) {
            console.error('Error fetching country data:', error);
        }
    }

    function buildSpecsImageWrap(imageUrls, imageMargin) {
        var wrap = document.createElement('div');
        wrap.className = 'specs-table-modal__image-wrap';

        imageUrls.forEach(function (url) {
            var img = document.createElement('img');
            img.src = url;
            img.alt = 'Specifications';
            img.style.cssText = 'display:block;max-width:100%;height:auto;margin:' + imageMargin + ' auto;';
            wrap.appendChild(img);
        });

        return wrap;
    }

    function replaceElementChildren(element, newChild) {
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }

        if (newChild) {
            element.appendChild(newChild);
        }
    }

    /**
     * ========================================
     * Bundle Variant Selection
     * Handles variant selection for bundle products
     * ========================================
     */
    function initializeVariantSelection() {
        document.querySelectorAll('.collection-swatch-input').forEach(function (input) {
            input.addEventListener('change', function (event) {
                const target = event.target;
                const form = target.closest('#variant-selects-bundle-products');
                const selectedFieldset = target.closest('fieldset');

                if (!selectedFieldset) return;

                const selectedPos = selectedFieldset.getAttribute('data-pos');
                if (!selectedPos) return;

                let variantId = null;
                let variantPrice = 0;
                let variantTitle = '';

                if (target.classList.contains('custom-product-input')) {
                    variantId = target.value;
                    variantTitle = target.dataset.title || '';
                    variantPrice = parseFloat(target.dataset.inputPrice) || 0;
                } else {
                    if (!form) return;
                    const jsonElement = form.querySelector('[type="application/json"]');
                    if (!jsonElement) return;

                    const fieldsets = Array.from(form.querySelectorAll('fieldset'));
                    const options = fieldsets.map(function (f) {
                        const checked = f.querySelector("input[type='radio']:checked");
                        return checked ? checked.value : null;
                    });

                    try {
                        const allVariants = JSON.parse(jsonElement.textContent);
                        const currentVariant = allVariants.find(function (variant) {
                            return variant.options.every(function (opt, i) {
                                return opt === options[i];
                            });
                        });

                        if (!currentVariant) return;
                        console.log(currentVariant, 'currentVariant');

                        variantId = currentVariant.id;
                        variantTitle = currentVariant.title;
                        variantPrice = parseFloat(currentVariant.price) || 0;
                    } catch (err) {
                        return;
                    }
                }

                const inputToUpdate = document.querySelector(
                    '.input_bundle .input_var_id[data-pos="' + selectedPos + '"]'
                );
                console.log(selectedPos, 'selectedPos');
                console.log(inputToUpdate, 'inputToUpdate');

                if (inputToUpdate && variantId != null) {
                    inputToUpdate.value = variantId;
                    inputToUpdate.setAttribute('data-price', variantPrice);

                    const label = document.querySelector('label[for="' + inputToUpdate.id + '"]');
                    if (label) {
                        const titleEl = label.querySelector('.bundle_var_title');
                        if (titleEl) {
                            titleEl.innerText = variantTitle;
                        }
                    }
                }

                updateTotalPrice();
            });
        });

        updateTotalPrice();
    }

    /**
     * Updates the total price display for bundle products
     */
    function updateTotalPrice() {
        const inputs = document.querySelectorAll('.input_bundle .input_var_id');
        let total = 0;

        inputs.forEach(function (input) {
            total += parseFloat(input.getAttribute('data-price')) || 0;
        });

        if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && window.Money_Filter) {
            const formatted = Shopify.formatMoney(total, window.Money_Filter);
            const targetEl = document.querySelector('.total_append');
            if (targetEl) {
                targetEl.textContent = formatted;
            }
        }
    }

    /**
     * Adds all bundle items to cart
     */
    function addBundleToCart() {
        const inputs = document.querySelectorAll('.input_var_id');
        const itemsToAdd = [];

        inputs.forEach(function (input) {
            const variantId = input.value;
            if (variantId) {
                itemsToAdd.push({
                    id: variantId,
                    quantity: 1
                });
            }
        });

        if (itemsToAdd.length === 0) {
            return;
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: itemsToAdd })
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                window.location.href = '/cart';
            })
            .catch(function (err) {
                console.error('Cart add error:', err);
                alert('Something went wrong. Try again.');
            });
    }

    // Expose addBundleToCart globally for onclick handlers
    window.addBundleToCart = addBundleToCart;

    // Expose initializeVariantSelection globally - called from global.js after dynamic content load
    window.initializeVariantSelection = initializeVariantSelection;

    /**
     * ========================================
     * Menu Drawer Click Outside Handler
     * Closes the menu drawer when clicking outside of it
     * ========================================
     */
    function initMenuDrawerClickOutside() {
        document.addEventListener('click', function (event) {
            const menuDrawer = document.querySelector('header-drawer details');
            const summary = menuDrawer ? menuDrawer.querySelector('summary') : null;

            // If menuDrawer doesn't exist, exit
            if (!menuDrawer) return;

            // Check if the click happened outside the header-drawer
            const clickedOutside = !menuDrawer.contains(event.target);

            if (clickedOutside && menuDrawer.hasAttribute('open')) {
                // Remove the 'open' attribute and class
                menuDrawer.removeAttribute('open');
                menuDrawer.classList.remove('menu-opening');

                // Set aria-expanded to false
                if (summary) {
                    summary.setAttribute('aria-expanded', 'false');
                }
            }
        });
    }

    /**
     * ========================================
     * Cart Drawer Click Outside Handler
     * Closes the cart drawer when clicking outside of it
     * ========================================
     */
    function initCartDrawerClickOutside() {
        document.addEventListener('click', function (event) {
            const cartDrawer = document.querySelector('cart-drawer');
            if (!cartDrawer) return;

            const clickedOutside = !cartDrawer.contains(event.target);
            // Check if the drawer is open (Shopify adds "is-open" class)
            const isOpen = cartDrawer.classList.contains('is-open');

            if (clickedOutside && isOpen) {
                cartDrawer.classList.remove('is-open');
                cartDrawer.removeAttribute('open');
                // Optionally, update aria attributes if your button uses one
                const toggleButton = document.querySelector('[aria-controls="CartDrawer"]');
                if (toggleButton) {
                    toggleButton.setAttribute('aria-expanded', 'false');
                }
            }
        });
    }

    /**
     * ========================================
     * Cart Drawer Subtotal Handler
     * Handles removing 'active' class when subtotal is 0
     * ========================================
     */
    function initCartDrawerSubtotalHandler() {
        document.addEventListener('click', function (event) {
            const cartDrawer = document.querySelector('cart-drawer.drawer');
            if (!cartDrawer) return;

            // Subtotal element — adjust selector as per your theme
            const subtotalEl = cartDrawer.querySelector('.totals__total-value, .cart-subtotal, [data-cart-subtotal]');
            let subtotal = 0;

            if (subtotalEl) {
                subtotal = parseFloat(subtotalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
            }

            const clickedOutside = !cartDrawer.contains(event.target);

            // Remove 'active' if subtotal = 0 and clicked outside
            if (clickedOutside && subtotal === 0 && cartDrawer.classList.contains('active')) {
                cartDrawer.classList.remove('active');
            }
        });
    }

    /**
     * ========================================
     * Specs Table Modal
     * Opens a popup with full table content when 'View full specs' is clicked.
     * Triggered by any .specs-table-trigger button rendered next to a table
     * inside the product_tab2_new (or any collapsible_tab) accordion content.
     * ========================================
     */
    // function initSpecsTableModal() {
    //     var modal = document.getElementById('specs-table-modal');
    //     if (!modal) return;

    //     var modalBody = document.getElementById('specs-table-modal-body');

    //     /**
    //      * Opens the modal and copies content from the source accordion block.
    //      * @param {string} sourceBlockId - id of the accordion__content element
    //      */
    //     function openSpecsModal(sourceBlockId) {
    //         var sourceEl = document.getElementById(sourceBlockId);
    //         if (!sourceEl || !modalBody) return;

    //         // Copy only the inner HTML of the accordion content div.
    //         // We deliberately do NOT clone the wrapper element itself because
    //         // it carries .accordion__content CSS (max-height: 1000px, overflow: hidden)
    //         // which would clip the table rows inside the modal.
    //         var innerHtml = sourceEl.innerHTML;

    //         // Strip out any "View full specs" trigger buttons from the copied markup
    //         var temp = document.createElement('div');
    //         temp.innerHTML = innerHtml;
    //         temp.querySelectorAll('.specs-table-trigger').forEach(function (t) {
    //             t.parentNode.removeChild(t);
    //         });

    //         modalBody.innerHTML = temp.innerHTML;

    //         // Open using native <dialog> API if available, else fallback
    //         if (typeof modal.showModal === 'function') {
    //             modal.showModal();
    //         } else {
    //             modal.setAttribute('open', '');
    //         }

    //         // Lock body scroll
    //         document.body.style.overflow = 'hidden';

    //         // Focus the close button for accessibility
    //         var closeBtn = modal.querySelector('.specs-table-modal__close');
    //         if (closeBtn) { closeBtn.focus(); }
    //     }

    //     function closeSpecsModal() {
    //         if (typeof modal.close === 'function') {
    //             modal.close();
    //         } else {
    //             modal.removeAttribute('open');
    //         }
    //         document.body.style.overflow = '';
    //     }

    //     // Delegate click on all current and future trigger buttons
    //     document.addEventListener('click', function (event) {
    //         var trigger = event.target.closest('.specs-table-trigger');
    //         if (trigger) {
    //             event.preventDefault();
    //             var sourceBlockId = trigger.getAttribute('data-specs-block-id');
    //             openSpecsModal(sourceBlockId);
    //             return;
    //         }

    //         // Close when clicking the overlay or close button
    //         if (event.target.closest('[data-specs-modal-close]')) {
    //             closeSpecsModal();
    //         }
    //     });

    //     // Close on Escape key
    //     document.addEventListener('keydown', function (event) {
    //         if ((event.key === 'Escape' || event.key === 'Esc') && (modal.open || modal.hasAttribute('open'))) {
    //             closeSpecsModal();
    //         }
    //     });

    //     // Native <dialog> cancel event (Esc in Chrome/Firefox)
    //     modal.addEventListener('cancel', function (event) {
    //         event.preventDefault();
    //         closeSpecsModal();
    //     });
    // }

    // Some published product pages include the zoom script without the modal snippet.
    // Reuse the Liquid-rendered dialog, or supply the same structure before binding events.
    function ensureSpecsTableModal() {
        var existingModal = document.getElementById('specs-table-modal');
        if (existingModal) return existingModal;

        var hasSpecs = document.querySelector('.specs-table-trigger') ||
            Array.from(document.querySelectorAll('.accordion__title')).some(function (title) {
                return /technical specification|specs/i.test(title.textContent || '');
            });
        if (!hasSpecs) return null;

        function createElement(tag, className, parent) {
            var element = document.createElement(tag);
            element.className = className;
            parent.appendChild(element);
            return element;
        }

        var modal = document.createElement('dialog');
        modal.id = 'specs-table-modal';
        modal.className = 'specs-table-modal';
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-label', 'Full Specifications');

        var overlay = createElement('div', 'specs-table-modal__overlay', modal);
        overlay.setAttribute('data-specs-modal-close', '');
        var dialog = createElement('div', 'specs-table-modal__dialog', modal);
        dialog.setAttribute('role', 'document');
        var header = createElement('div', 'specs-table-modal__header', dialog);
        createElement('h2', 'specs-table-modal__title', header).textContent = 'Technical Specifications';
        var closeBtn = createElement('button', 'specs-table-modal__close', header);
        closeBtn.type = 'button';
        closeBtn.setAttribute('data-specs-modal-close', '');
        closeBtn.setAttribute('aria-label', 'Close specifications');

        var svgNamespace = 'http://www.w3.org/2000/svg';
        var icon = document.createElementNS(svgNamespace, 'svg');
        icon.setAttribute('width', '18');
        icon.setAttribute('height', '18');
        icon.setAttribute('viewBox', '0 0 18 18');
        icon.setAttribute('aria-hidden', 'true');
        var path = document.createElementNS(svgNamespace, 'path');
        path.setAttribute('d', 'M3 3L15 15M15 3L3 15');
        path.setAttribute('stroke', 'currentColor');
        path.setAttribute('stroke-width', '2');
        icon.appendChild(path);
        closeBtn.appendChild(icon);
        createElement('div', 'specs-table-modal__body rte', dialog).id = 'specs-table-modal-body';
        document.body.appendChild(modal);
        return modal;
    }

    function initSpecsTableModal() {
        var modal = ensureSpecsTableModal();
        if (!modal) return;

        var modalBody = document.getElementById('specs-table-modal-body');

        function cloneSpecsContent(sourceEl) {
            var fragment = document.createDocumentFragment();

            Array.from(sourceEl.childNodes).forEach(function (node) {
                fragment.appendChild(node.cloneNode(true));
            });

            fragment.querySelectorAll('.specs-table-trigger').forEach(function (trigger) {
                trigger.remove();
            });

            return fragment;
        }

        /**
         * Opens the modal and copies content from the source accordion block.
         * @param {string} sourceBlockId - id of the accordion__content element
         */
        function openSpecsModal(sourceBlockId) {
            if (!modalBody) return;

            var sourceEl = document.getElementById(sourceBlockId);
            if (!sourceEl) return;

            replaceElementChildren(modalBody, cloneSpecsContent(sourceEl));

            // Open using native <dialog> API if available, else fallback
            if (typeof modal.showModal === 'function') {
                modal.showModal();
            } else {
                modal.setAttribute('open', '');
            }

            // Lock body scroll
            document.body.style.overflow = 'hidden';

            // Focus the close button for accessibility
            var closeBtn = modal.querySelector('.specs-table-modal__close');
            if (closeBtn) { closeBtn.focus(); }
        }

        function closeSpecsModal() {
            if (typeof modal.close === 'function') {
                modal.close();
            } else {
                modal.removeAttribute('open');
            }
            document.body.style.overflow = '';
        }

        // Delegate click on all current and future trigger buttons
        document.addEventListener('click', function (event) {
            var trigger = event.target.closest('.specs-table-trigger');
            if (trigger) {
                event.preventDefault();
                var sourceBlockId = trigger.getAttribute('data-specs-block-id');
                openSpecsModal(sourceBlockId);
                return;
            }

            // Close when clicking the overlay or close button
            if (event.target.closest('[data-specs-modal-close]')) {
                closeSpecsModal();
            }
        });

        // Close on Escape key
        document.addEventListener('keydown', function (event) {
            if ((event.key === 'Escape' || event.key === 'Esc') && (modal.open || modal.hasAttribute('open'))) {
                closeSpecsModal();
            }
        });

        // Native <dialog> cancel event (Esc in Chrome/Firefox)
        modal.addEventListener('cancel', function (event) {
            event.preventDefault();
            closeSpecsModal();
        });
    }

    /**
     * ========================================
     * Per-item Spec Zoom (Fully Dynamic)
     * Enhances all spec images in Technical Specifications accordions
     * (rendered directly from Shopify product metafields) with
     * click-to-zoom capabilities and overlay zoom buttons.
     * ========================================
     */
    function initPerItemSpecZoom() {
        var modal = document.getElementById('specs-table-modal');
        var modalBody = document.getElementById('specs-table-modal-body');
        if (!modal || !modalBody) return;

        function getSpecsAccordionContainers() {
            var containers = [];

            // 1. Target via .specs-table-trigger block ID
            document.querySelectorAll('.specs-table-trigger').forEach(function (trigger) {
                var sourceBlockId = trigger.getAttribute('data-specs-block-id');
                var el = sourceBlockId ? document.getElementById(sourceBlockId) : null;
                if (el && containers.indexOf(el) === -1) {
                    containers.push(el);
                }
            });

            // 2. Target via accordion titles containing "Technical Specification" or "Specs"
            document.querySelectorAll('.accordion__title').forEach(function (titleEl) {
                var text = (titleEl.textContent || '').toLowerCase();
                if (text.indexOf('technical specification') !== -1 || text.indexOf('specs') !== -1) {
                    var wrapper = titleEl.closest('.accordion, details, .product__accordion');
                    if (wrapper) {
                        var contentEl = wrapper.querySelector('.accordion__content, [id^="ProductAccordion-"]');
                        if (contentEl && containers.indexOf(contentEl) === -1) {
                            containers.push(contentEl);
                        }
                    }
                }
            });

            return containers;
        }

        var specContainers = getSpecsAccordionContainers();
        if (!specContainers.length) return;

        specContainers.forEach(function (sourceEl) {
            if (sourceEl.dataset.perItemZoomInit) return;
            sourceEl.dataset.perItemZoomInit = '1';

            // Dynamically enhance inline spec images from product metafields with zoom functionality
            var imgs = sourceEl.querySelectorAll('img');
            imgs.forEach(function (img) {
                if (img.closest('.spec-zoom-wrap')) return;
                var parent = img.parentNode;
                var url = img.src;
                var wrap = buildZoomItem(url, img);
                if (parent) {
                    parent.replaceChild(wrap, img);
                }
            });
        });

        function buildZoomItem(url, existingImg) {
            var wrap = document.createElement('div');
            wrap.className = 'spec-zoom-wrap';
            wrap.style.cssText = 'position:relative;display:block;margin:1.6rem 0;cursor:zoom-in;';

            var img;
            if (existingImg) {
                img = existingImg.cloneNode(true);
                img.style.cssText = (img.style.cssText || '') + ';display:block;max-width:100%;height:auto;margin:0 auto;cursor:zoom-in;';
            } else {
                img = document.createElement('img');
                img.src = url;
                img.alt = 'Specifications';
                img.loading = 'lazy';
                img.style.cssText = 'display:block;max-width:100%;height:auto;margin:0 auto;cursor:zoom-in;';
            }

            wrap.appendChild(img);

            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'spec-zoom-btn';
            btn.setAttribute('aria-label', 'View larger');
            btn.appendChild(buildZoomIcon());
            btn.style.cssText = 'position:absolute;top:8px;right:8px;width:34px;height:34px;border-radius:50%;border:none;background:rgba(17,17,17,0.78);color:#fff;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;z-index:2;padding:0;box-shadow:0 2px 6px rgba(0,0,0,0.18);';
            wrap.appendChild(btn);

            function open(e) {
                if (e) { e.preventDefault(); e.stopPropagation(); }
                openSingleImage(url);
            }

            btn.addEventListener('click', open);
            wrap.addEventListener('click', function (e) {
                if (e.target === btn || btn.contains(e.target)) return;
                open(e);
            });

            return wrap;
        }

        function buildZoomIcon() {
            var svgNamespace = 'http://www.w3.org/2000/svg';
            var svg = document.createElementNS(svgNamespace, 'svg');
            var iconAttrs = {
                width: '14',
                height: '14',
                viewBox: '0 0 24 24',
                fill: 'none',
                stroke: 'currentColor',
                'stroke-width': '2.2',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round'
            };

            Object.keys(iconAttrs).forEach(function (name) {
                svg.setAttribute(name, iconAttrs[name]);
            });

            var circle = document.createElementNS(svgNamespace, 'circle');
            circle.setAttribute('cx', '11');
            circle.setAttribute('r', '7');
            circle.setAttribute('cy', '11');
            svg.appendChild(circle);

            [
                ['21', '21', '16.5', '16.5'],
                ['11', '8', '11', '14'],
                ['8', '11', '14', '11']
            ].forEach(function (coords) {
                var line = document.createElementNS(svgNamespace, 'line');
                line.setAttribute('x1', coords[0]);
                line.setAttribute('y1', coords[1]);
                line.setAttribute('x2', coords[2]);
                line.setAttribute('y2', coords[3]);
                svg.appendChild(line);
            });

            return svg;
        }

        function openSingleImage(url) {
            replaceElementChildren(modalBody, buildSpecsImageWrap([url], '0'));

            if (typeof modal.showModal === 'function') {
                modal.showModal();
            } else {
                modal.setAttribute('open', '');
            }

            document.body.style.overflow = 'hidden';
            var closeBtn = modal.querySelector('.specs-table-modal__close');
            if (closeBtn) closeBtn.focus();
        }
    }

    /**
     * ========================================
     * Shipping Info Popup on Add to Cart
     * Intercepts cart form submission when a variant-specific shipping
     * message is present, shows a confirmation popup, and only proceeds
     * with the Ajax cart add after the user acknowledges the message.
     * ========================================
     */
    function initShippingInfoPopup() {
        // Check if shipping popup is enabled via window variable
        // Liquid sets this: window.shippingPopupEnabled = true
        if (!window.shippingPopupEnabled) {
            return; // Don't initialize popup if not enabled for this product
        }

        var form = document.querySelector('form[action*="/cart/add"]');
        if (!form) return;

        // Inject styles
        var style = document.createElement('style');
        style.textContent =
            '#shipping-info-popup{display:none;position:fixed;bottom:0;left:0;right:0;top:0;z-index:99999;align-items:center;justify-content:center;}' +
            '#shipping-info-popup.mobile{flex-direction:column;justify-content:flex-end;padding-bottom:260px;}' +
            '.shipping-popup__overlay{position:absolute;inset:0;background:rgba(0,0,0,0.55);}' +
            '.shipping-popup__box{position:relative;background:#fff;border:10px solid #8297b2;border-radius:12px;padding:32px 28px 28px;max-width:420px;width:90%;text-align:center;box-shadow:0 8px 32px rgba(0,0,0,0.2);}' +
            '#shipping-info-popup.mobile .shipping-popup__box{border-radius:12px;width:85vw;max-width:none;margin:0 auto 24px;}' +
            '.shipping-popup__title{font-size:18px;font-weight:700;margin:0 0 16px;letter-spacing:0.04em;text-transform:uppercase;}' +
            '.shipping-popup__message{font-size:15px;line-height:1.6;margin:0 0 24px;color:#333;}' +
            '.shipping-popup__btn{display:inline-block;padding:14px 48px;background:#8297b2;color:#fff;border:none;border-radius:24px;font-size:16px;font-weight:600;cursor:pointer;letter-spacing:0.06em;transition:background 0.2s;}' +
            '.shipping-popup__btn:hover{background:#6b7fa3;}' +
            '@media (max-width:749px){#shipping-info-popup.mobile{padding-bottom:280px;}}';
        document.head.appendChild(style);

        // Inject modal HTML
        var popup = document.createElement('div');
        popup.id = 'shipping-info-popup';
        popup.setAttribute('role', 'dialog');
        popup.setAttribute('aria-modal', 'true');
        popup.setAttribute('aria-labelledby', 'shipping-popup-title');

        var overlay = document.createElement('div');
        overlay.className = 'shipping-popup__overlay';

        var box = document.createElement('div');
        box.className = 'shipping-popup__box';

        var title = document.createElement('h2');
        title.className = 'shipping-popup__title';
        title.id = 'shipping-popup-title';
        title.textContent = 'Important Shipping Info';

        var message = document.createElement('p');
        message.className = 'shipping-popup__message';
        message.id = 'shipping-popup-message';

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'shipping-popup__btn';
        button.id = 'shipping-popup-ok';
        button.textContent = 'OK';

        box.appendChild(title);
        box.appendChild(message);
        box.appendChild(button);
        popup.appendChild(overlay);
        popup.appendChild(box);
        document.body.appendChild(popup);

        // Detect if mobile and add class for bottom-sticky positioning
        function updateMobileClass() {
            if (window.innerWidth < 750) {
                popup.classList.add('mobile');
            } else {
                popup.classList.remove('mobile');
            }
        }
        updateMobileClass();
        window.addEventListener('resize', updateMobileClass);

        var messageEl = document.getElementById('shipping-popup-message');
        var okBtn = document.getElementById('shipping-popup-ok');
        var pendingForm = null;
        var skipPopup = false;

        function openPopup(message, form) {
            pendingForm = form;
            messageEl.textContent = message;
            popup.style.display = 'flex';
            document.body.style.overflow = 'hidden';
            okBtn.focus();
        }

        function closePopup() {
            popup.style.display = 'none';
            document.body.style.overflow = '';
        }

        okBtn.addEventListener('click', function () {
            closePopup();
            if (pendingForm) {
                // Set flag so our capture listener lets this submission pass through
                skipPopup = true;
                pendingForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                pendingForm = null;
            }
        });

        // Capture-phase listener fires before ProductForm's bubble-phase onSubmitHandler.
        // stopImmediatePropagation prevents the event reaching the form entirely while
        // the popup is open; re-dispatching after OK (with skipPopup=true) lets it
        // proceed normally through ProductForm's Ajax cart logic.
        document.addEventListener('submit', function (event) {
            var form = event.target;
            if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;

            if (skipPopup) {
                skipPopup = false;
                return;
            }

            // Search for the active shipping message: scoped to product container first,
            // then fall back to document-wide so it works across different template layouts.
            var shippingInput = null;
            var searchRoots = [
                form.closest('product-form'),
                document.querySelector('#product__info_main'),
                document.querySelector('.product__info-wrapper'),
                document.querySelector('.product-info'),
                document
            ];

            for (var i = 0; i < searchRoots.length; i++) {
                if (!searchRoots[i]) continue;
                shippingInput = searchRoots[i].querySelector(
                    '.variant-shipping-message.active input[name="properties[Shipping Info]"]'
                );
                if (shippingInput) break;
            }

            if (!shippingInput) return;

            var message = shippingInput.value.trim();
            if (!message) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            openPopup(message, form);
        }, true /* capture phase */);

        // Allow keyboard dismissal (closes without adding to cart)
        document.addEventListener('keydown', function (event) {
            if ((event.key === 'Escape' || event.key === 'Esc') && popup.style.display !== 'none') {
                closePopup();
                pendingForm = null;
            }
        });
    }

    /**
     * ========================================
     * WOW.js Initialization
     * Initializes the WOW animation library
     * ========================================
     */
    function initWOW() {
        if (typeof WOW !== 'undefined') {
            new WOW().init();
        }
    }

    /**
     * ========================================
     * Initialize All Components
     * Called when DOM is ready
     * ========================================
     */
    function init() {
        // Initialize page reload handling immediately
        initPageReloadHandling();

        // Initialize country detection
        fetchDatacart();

        // Initialize bundle variant selection
        initializeVariantSelection();

        // Initialize click outside handlers
        initMenuDrawerClickOutside();
        initCartDrawerClickOutside();
        initCartDrawerSubtotalHandler();

        // Initialize shipping info popup
        initShippingInfoPopup();

        // Initialize specs table modal
        initSpecsTableModal();

        // Initialize per-item spec zoom (product-specific override)
        initPerItemSpecZoom();

        // Initialize WOW.js
        initWOW();
    }

    // Run initialization
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
